import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Button = styled(Link)`
  text-align: center;
  padding: 17px 23px;
  border-radius: 6px;
  background-color: rgba(255, 255, 255, 0);
  font-weight: ${({ fontWeight }) => fontWeight};
  border: 1px solid ${({ color }) => color};
  color: ${({ color }) => color};
  max-width: ${({ maxwidth }) => maxwidth};
  min-width: ${({ minwidth }) => minwidth};
  width: ${({ width }) => width};
  margin: ${({ margin }) => margin};
  max-height: ${({ maxheight }) => maxheight};
  min-height: ${({ minheight }) => minheight};
  transition: 0.5s;
  font-size: ${({ fontSize }) => fontSize};
  cursor: pointer;
  text-decoration: unset;

  :hover {
    transition: 0.5s;
    box-shadow: 0 0 23px rgba(255, 255, 255, 0.6);
    text-decoration: unset; 
    color:white;
  }
`;

export const ButtonNormalLink = styled.a`
  white-space: nowrap;  
  text-align: center;
  padding: 17px 23px;
  border-radius: 6px;
  background-color: rgba(255, 255, 255, 0);
  font-weight: ${({ fontWeight }) => fontWeight};
  border: 1px solid ${({ color }) => color};
  color: ${({ color }) => color};
  max-width: ${({ maxwidth }) => maxwidth};
  min-width: ${({ minwidth }) => minwidth};
  width: ${({ width }) => width};
  margin: ${({ margin }) => margin};
  max-height: ${({ maxheight }) => maxheight};
  min-height: ${({ minheight }) => minheight};
  transition: 0.5s;
  font-size: ${({ fontSize }) => fontSize};
  cursor: pointer;
  text-decoration: unset;

  :hover {
    transition: 0.5s;
    box-shadow: 0 0 23px rgba(255, 255, 255, 0.6);
    text-decoration: unset; 
    color:white;
  }

  @media screen and (max-width: 992px) {
    width: 275px;
  }
`;


